<template lang="pug">
.content-wrap
	topbar
	.content-top
		.con
			//- highlight
			rtt
			googleSearch
			.cat-tab.nbswi(ref="categories")
				.swiper.glcat-swiper.nbswi-swiper
					.swiper-wrapper
						//- .swiper-slide
							.cat(@click="redirectPath('/')")
								img(src='/new/img/tab/c-hot.png')
								| hot
						.swiper-slide
							.cat(@click="redirectPath('/slot')")
								img(src='/new/img/tab/c-slot.png')
								| slots
						template(v-if="isLoggedIn")
							.swiper-slide
								router-link.cat(to="/launchWbet" target="_blank")
									img(src='/new/img/tab/c-sport.png')
									| sports
						template(v-else)
							.swiper-slide
								a.cat(@click="$router.push('/login').catch(err => {})")
									img(src='/new/img/tab/c-sport.png')
									| sports
						.swiper-slide
							.cat(@click="redirectPath('/casino')")
								img(src='/new/img/tab/c-casino.png')
								| live
						.swiper-slide
							.cat(@click="redirectPath('/table')")
								img(src='/new/img/tab/c-poker.png')
								| poker
						.swiper-slide
							.cat.aaa
								img(src='/new/img/tab/c-bingo.png')
								| bingo
						template(v-if="isLoggedIn")
							.swiper-slide
								router-link.cat(to="/launchWbet" target="_blank")
									img(src='/new/img/tab/c-sport.png')
									| sports
						template(v-else)
							.swiper-slide
								a.cat(@click="$router.push('/login').catch(err => {})")
									img(src='/new/img/tab/c-sport.png')
									| sports
						.swiper-slide
							.cat(@click="redirectPath('/fishing')")
								img(src='/new/img/tab/c-fish.png')
								| fishing
						.swiper-slide
							.cat(@click="redirectPath('/minigame')")
								img(src='/new/img/tab/c-arcade.png')
								| minigame
						.swiper-slide
							.cat(@click="redirectPath('/crash')")
								img(src='/new/img/tab/c-crash.png')
								| crash
						//- .swiper-slide
							.cat(@click="redirectPath('/lottery')")
								img(src='/new/img/tab/c-lottery.png')
								| lottery
				.swiper-button-prev.glcat-swiper-prev
				.swiper-button-next.glcat-swiper-next
			template(v-if="providerList.length > 0")
				.searchbar
					.fav.pointer(v-if="isLoggedIn" @click="toggleFav")
						i.fa-heart(:class="{'fa-solid fav-red': showFav, 'fa-regular': !showFav}")
					.fav.pointer(v-if="!isLoggedIn" @click="$router.push('/login').catch(err => {})")
						i.fa-regular.fa-heart
					input.form-control(type='text' v-model="searchinput" placeholder='Search')
					.s-icon
						i.fa-solid.fa-magnifying-glass
				.glmenu.nbswi.mt-2
					.swiper.glpro-swiper.nbswi-swiper
						.swiper-wrapper
							.swiper-slide(v-for="(provider, index) in providerList" @click="changeProvider(provider.provider_code)")
								.g-pro.pro(:class="{'aaa' : providerSelected === provider.provider_code }")
									img(:src="getImg(provider.provider_code)")
					.swiper-button-prev.glpro-swiper-prev
					.swiper-button-next.glpro-swiper-next
				favList(v-if="showFav" :searchinput="searchinput")
				gameList(v-if="!showFav && pageLoading==false" :searchinput="searchinput" :gameType="'bingo'" :pCode="providerSelected" :key="providerSelected")
			template(v-else)
				.text-center.text-white.my-4.w-100
					i.fa-regular.fa-newspaper.display-6.text-black
					.text-black No data
			footerInfo(:target="'/bingo'")
</template>
<script>
import { EventBus } from '@/store/event';
import config from "@/config";
import topbar from '@/views/default/_topBar.vue'
import highlight from '@/component/_highlight.vue'
import rtt from '@/component/_realTimeTrans.vue'
import favList from '@/component/bingo/_favList.vue'
import footerInfo from '@/views/default/_footerArticle.vue'
import imgList from '@/providerImg'
import gameList from '@/component/_gameList.vue'
import social from '@/component/_social.vue'
import googleSearch from '@/component/_googleSearch.vue'
export default {
	components:{
		topbar,
		highlight,
    rtt,
		favList,
		imgList,
		gameList,
		footerInfo,
    social,
		googleSearch
	},
	data(){
		return{
			feedback: {
				success: true,
				status: ""
			},
			loading:false,
			showMobile: false,
			providerSelected: null,
			imgUrl: config.imageUrl,
			showSearch: false,
			searchinput:"",
			showFav: false,
			providerImg: imgList.provider,
      pageLoading:true,
      providerList:[],
		}
	},
	computed: {
		isLoggedIn(){
			return this.$store.getters.isLoggedIn
		},
		accountID() {
			return this.$store.getters.accountID
		},
		sessionToken() {
			return this.$store.getters.sessionToken
		},
		getProvider(){
			return this.providerList[this.providerSelected]
		},
	},
	created(){
		// this.getSeo("poker")
		$('link[rel="canonical"]').attr('href', `${window.location.protocol}//${window.location.hostname}/bingo`);
	},
	mounted(){
		// EventBus.$on("scroll", (data) => {
		// 	if(data == true){
		// 		this.$nextTick(() => {
		// 			// then wait for the browser’s layout/paint
		// 			requestAnimationFrame(() => {
		// 				setTimeout(this.scrolltoDiv, 500)
		// 			})
		// 		})
		// 	}
		// });
		if ($('.glcat-swiper').length) {
			const gboxSwiper = new Swiper('.glcat-swiper', {
				slidesPerView: 4.5,
				spaceBetween: 4,
				navigation: {
					nextEl: '.glcat-swiper-next',
					prevEl: '.glcat-swiper-prev'
				},
				// watchOverflow: true,
				autoplay:false,
				breakpoints: {
					768: {
						slidesPerView: 4.5
					},
					960: {
						slidesPerView: 6
					}
				}
			})
    }
		this.getProviderlist()
	},
	methods:{
		initSwiper(){
			// if (this.gboxSwiper) this.gboxSwiper.destroy(true,true)
			const gboxSwiper = new Swiper('.glpro-swiper', {
				slidesPerView: 3.5,
				spaceBetween: 4,
				navigation: {
					nextEl: '.glpro-swiper-next',
					prevEl: '.glpro-swiper-prev'
				},
				watchOverflow: true,
				autoplay:false,
				breakpoints: {
					768: { slidesPerView: 6.5 },
					960: { slidesPerView: 6.5 }
				},
				// make Swiper react to DOM changes
				observer: true,
				observeParents: true,
				observeSlideChildren: true,
			})
		},
		redirectPath(target){
      this.$router.push(target).catch(error =>{}).finally(() => {
        this.$nextTick(() => {
          EventBus.$emit('scroll', true);
        });
      });
    },
		scrolltoDiv(){
			const el = this.$refs.categories
      if (!el) return
			
      el.scrollIntoView({ behavior: 'smooth', block: 'start', inline: "nearest" })
		},
		openModal(){
			$("#logModal").modal('show')
		},
		toggleFav(){
			this.showFav = !this.showFav
		},
		toggleSearch(){
			this.showSearch = !this.showSearch
		},
		cancelSearch(){
			this.showSearch = false
			this.searchinput = ""
		},
		getSeo(page){
			let page_name = page
			this.$store
				.dispatch("user/getSeo", {page_name})
				.then(response => {
					this.loading = false;
					this.feedback.success = response.success
					if (this.feedback.success == true) {
						if(response.data.length > 0){
							// this.$store.dispatch("user/seoInfo", response.data[0])
						}
					} else {
						if((typeof response.status) != 'object'){
							this.$helpers.showDialog(vm.$tc("ui.attention"), vm.$tc("message.list." + response.status), "info", this)
						}       
					}
				})
				.catch(response => {
					this.loading = false;
					var vm = this;
					if((typeof response.status) != 'object'){
						this.$helpers.showDialog(vm.$tc("ui.attention"), vm.$tc("message.list." + response.status), "info", this)
					}
				});
		},
		changeProvider(option){
			if(option !== this.providerSelected){
				this.providerSelected = option
			}
			this.showFav = false
			// if(option === this.providerSelected){
			// 	return
			// }else{
			// 	this.providerSelected = option
			// }
		},
		getProviderlist(){
      this.pageLoading = true
			var url = config.getProviderlist()
      this.$http.post(url, {
        "category": "BINGO"
      }).then(
        successResponse => {
          if(successResponse){
            if (typeof successResponse.data.status == "string") {
              this.feedback.success = successResponse.status == "200";
            } else {
              this.feedback.success = successResponse.status == 200;
            }
            this.feedback.status = successResponse.status;
            if (this.feedback.success == true) {
							if(successResponse.data.value.length > 0){
								this.providerList = successResponse.data.value
								this.providerSelected = this.providerList[0].provider_code
								this.$nextTick(this.initSwiper)
							}
            } else {
            }
						this.pageLoading = false
          }else{
          }
        },
        errorResponse => {
          this.pageLoading = false
          console.log(errorResponse)
        }
      );
    },
    getImg(code){
			return `/new/img/provider/${this.providerImg[code]}.png`
		}
	}
}
</script>